export default {"src":"/_next/static/media/shoppingCart_64.2d57121d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};